import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const metadata = {
  title: "Interactive Clarifications",
  published_at: "2026-02-19",
  summary: "The AI assistant now generates dynamic UI elements to ask clarifying questions, making conversations faster and more precise.",
  tags: ["AI"],
  draft: false
};
export const sections = [];
function _createMdxContent(props) {
  const _components = {
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {ChangelogVideo} = _components;
  if (!ChangelogVideo) _missingMdxReference("ChangelogVideo", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Instead of going back and forth with open-ended questions, the AI assistant can now present you with interactive options right in the chat. Need to narrow down a search? The assistant generates clickable choices so you can steer the conversation with a single tap instead of typing out your answer. It adapts the options based on context — different questions surface different UI depending on what you're working on."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "d4edb0dd-4c3a-5b70-9f99-94778a5b0d9b"
    }), "\n", _jsx(_components.p, {
      children: "This makes working with the assistant feel more like a guided conversation than a blank prompt. Less guessing, fewer misunderstandings, and faster results."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
